module.exports = __webpack_public_path__ + "static/media/dircks_image.e0f2500a.jpg";